import React from 'react';
import {useIntl} from 'react-intl';
import PropTypes from 'prop-types';

const I18nText = props => {
    const intl = useIntl();

    return <span {...props} dangerouslySetInnerHTML={{__html: props.content ? props.content[intl.locale] : null}}/>;
};

I18nText.propTypes = {
    content: PropTypes.object,
    className: PropTypes.string
};

export default I18nText;
